import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function atendimentoReducer(state = initialState.atendimento, action){
    switch(action.type) {
        case types.ENVIAR_PROTOCOLOS_CIDADAO:
            
            return {...state, enviado: action.payload};;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/atendimentoReducer.js
 **/